import { ArrowUpDown, Check } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { SortDirection, SortField, type SortSpec } from '@/domain/shared/sortOptions';

function isActive(active: SortSpec | undefined, s: SortSpec) {
  const aDir = active?.direction ?? SortDirection.Asc;
  const sDir = s.direction ?? SortDirection.Asc;

  return active?.field === s.field && aDir === sDir;
}

export function ArrayItemsSortMenu(props: {
  disabled?: boolean;
  activeSort?: SortSpec;
  onSelect: (spec: SortSpec) => void;
}) {
  const { disabled = false, activeSort, onSelect } = props;

  const Item = ({ spec, label }: { spec: SortSpec; label: string }) => (
    <DropdownMenuItem onClick={() => onSelect(spec)} className="flex items-center justify-between">
      <span>{label}</span>
      {isActive(activeSort, spec) ? <Check className="h-4 w-4" /> : null}
    </DropdownMenuItem>
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={disabled} aria-label="Sort">
          <ArrowUpDown className="mr-2 h-4 w-4" />
          Sort
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-48">
        <Item spec={{ field: SortField.Title, direction: SortDirection.Asc }} label="Title (A → Z)" />
        <Item spec={{ field: SortField.Title, direction: SortDirection.Desc }} label="Title (Z → A)" />

        <DropdownMenuSeparator />

        <Item spec={{ field: SortField.UpdatedAt, direction: SortDirection.Desc }} label="Recently updated" />
        <Item spec={{ field: SortField.UpdatedAt, direction: SortDirection.Asc }} label="Oldest updated" />

        <DropdownMenuSeparator />

        <Item spec={{ field: SortField.None }} label="Manual" />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
